export const API_URL = 'https://seilapp.vamibk.at'
